import { render } from "./ContactUsButton.vue?vue&type=template&id=073857d8&scoped=true"
import script from "./ContactUsButton.vue?vue&type=script&lang=js"
export * from "./ContactUsButton.vue?vue&type=script&lang=js"

import "./ContactUsButton.vue?vue&type=style&index=0&id=073857d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073857d8"]])

export default __exports__